import React, { useEffect, useRef, useState } from "react";
import "../assets/css/googleTranslate.css";
import { initGoogleTranslate, changeLanguage as managerChangeLanguage } from "./Googletranslatemanager";

const GoogleTranslate = () => {
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [isOpen, setIsOpen] = useState(false);

  const dropdownRef = useRef(null);

  const languages = [
    { code: "en", name: "English", shortName: "EN", nativeName: "English", flag: "🇬🇧" },
    { code: "hi", name: "Hindi", shortName: "HI", nativeName: "हिन्दी", flag: "🇮🇳" },
    { code: "gu", name: "Gujarati", shortName: "GU", nativeName: "ગુજરાતી", flag: "🇮🇳" },
    { code: "mr", name: "Marathi", shortName: "MR", nativeName: "मराठी", flag: "🇮🇳" },
    { code: "ta", name: "Tamil", shortName: "TA", nativeName: "தமிழ்", flag: "🇮🇳" },
    { code: "te", name: "Telugu", shortName: "TE", nativeName: "తెలుగు", flag: "🇮🇳" },
    { code: "kn", name: "Kannada", shortName: "KN", nativeName: "ಕನ್ನಡ", flag: "🇮🇳" },
    { code: "ml", name: "Malayalam", shortName: "ML", nativeName: "മലയാളം", flag: "🇮🇳" },
    { code: "bn", name: "Bengali", shortName: "BN", nativeName: "বাংলা", flag: "🇮🇳" },
    { code: "pa", name: "Punjabi", shortName: "PA", nativeName: "ਪੰਜਾਬੀ", flag: "🇮🇳" },
    { code: "es", name: "Spanish", shortName: "ES", nativeName: "Español", flag: "🇪🇸" },
    { code: "fr", name: "French", shortName: "FR", nativeName: "Français", flag: "🇫🇷" },
    { code: "de", name: "German", shortName: "DE", nativeName: "Deutsch", flag: "🇩🇪" },
    { code: "ar", name: "Arabic", shortName: "AR", nativeName: "العربية", flag: "🇸🇦" },
    { code: "ru", name: "Russian", shortName: "RU", nativeName: "Русский", flag: "🇷🇺" },
    { code: "ja", name: "Japanese", shortName: "JA", nativeName: "日本語", flag: "🇯🇵" },
    { code: "ko", name: "Korean", shortName: "KO", nativeName: "한국어", flag: "🇰🇷" },
    { code: "it", name: "Italian", shortName: "IT", nativeName: "Italiano", flag: "🇮🇹" },
    { code: "pt", name: "Portuguese", shortName: "PT", nativeName: "Português", flag: "🇵🇹" }
  ];

  const currentLanguage =
    languages.find((lang) => lang.code === selectedLanguage) || languages[0];

  const changeLanguage = (languageCode) => {
    setSelectedLanguage(languageCode);
    setIsOpen(false);
    managerChangeLanguage(languageCode);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const savedLanguage = localStorage.getItem("selectedLanguage");
    if (savedLanguage) {
      setSelectedLanguage(savedLanguage);
    }

    initGoogleTranslate();

    const handleLanguageChanged = (e) => {
      setSelectedLanguage(e.detail);
    };

    window.addEventListener("languageChanged", handleLanguageChanged);
    return () => {
      window.removeEventListener("languageChanged", handleLanguageChanged);
    };
  }, []);

  useEffect(() => {
    const removeGoogleBar = () => {
      document.body.style.top = "0px";

      const banner = document.querySelector(".goog-te-banner-frame");
      if (banner) {
        banner.style.display = "none";
      }
    };

    const interval = setInterval(removeGoogleBar, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="custom-language-selector"
      ref={dropdownRef}
    >
      <button
        className="language-selector-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select Language"
      >
        <svg
          className="globe-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="2" y1="12" x2="22" y2="12" />
          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
        </svg>

        <span className="language-short">
          {currentLanguage.shortName}
        </span>

        <svg
          className={`dropdown-arrow ${isOpen ? "open" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {isOpen && (
        <div className="language-dropdown-menu">
          <div className="language-dropdown-header">
            Select Language
          </div>

          <div className="language-dropdown-list">
            {languages.map((language) => (
              <button
                key={language.code}
                className={`language-option ${selectedLanguage === language.code
                  ? "active"
                  : ""
                  }`}
                onClick={() =>
                  changeLanguage(language.code)
                }
              >
                <span className="language-flag">
                  {language.flag}
                </span>

                <div className="language-info">
                  <span className="language-native">
                    {language.nativeName}
                  </span>

                  <span className="language-name-secondary">
                    {language.name}
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}

    </div>
  );
};

export default GoogleTranslate;